var _desc, _defs, _rect, _text, _g, _g2, _g3, _g4, _path, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreFuelAccountabilityProblemFragmentedEvidenceModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 820,
    height: 380,
    viewBox: "0 0 820 380",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore fragmented fuel evidence model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Four separate fuel-stop records converge on an accountability gap because they are not connected to one event.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcfepGap",
    x1: 350,
    y1: 98,
    x2: 490,
    y2: 282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fcfepShadow",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 14,
    floodColor: "#020716",
    floodOpacity: 0.35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 818,
    height: 378,
    rx: 28,
    fill: "#07152A",
    stroke: "#284260",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 44,
    fill: "#80C4FF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.6
  }, "FOUR RECORDS \xB7 NO CONNECTED EVENT")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 76,
    width: 276,
    height: 112,
    rx: 18,
    fill: "#0A1D38",
    stroke: "#087CFF",
    strokeOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 108,
    r: 8,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 113,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "DRIVER"), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 151,
    fill: "#AEBED1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "Who completed the stop?"), /*#__PURE__*/React.createElement("path", {
    d: "M54 168H182 M194 168H290",
    stroke: "#5C718C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 222,
    width: 276,
    height: 112,
    rx: 18,
    fill: "#0A1D38",
    stroke: "#FF2775",
    strokeOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 254,
    r: 8,
    fill: "#FF2775"
  }), /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 259,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "VEHICLE"), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 297,
    fill: "#AEBED1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "Which asset received fuel?"), /*#__PURE__*/React.createElement("path", {
    d: "M54 314H182 M194 314H290",
    stroke: "#5C718C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 76,
    width: 276,
    height: 112,
    rx: 18,
    fill: "#0A1D38",
    stroke: "#FF2775",
    strokeOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 108,
    r: 8,
    fill: "#FF2775"
  }), /*#__PURE__*/React.createElement("text", {
    x: 558,
    y: 113,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "ODOMETER"), /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 151,
    fill: "#AEBED1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "What distance was recorded?"), /*#__PURE__*/React.createElement("path", {
    d: "M530 168H658 M670 168H766",
    stroke: "#5C718C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 222,
    width: 276,
    height: 112,
    rx: 18,
    fill: "#0A1D38",
    stroke: "#087CFF",
    strokeOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 254,
    r: 8,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 558,
    y: 259,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800
  }, "FUEL SLIP"), /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 297,
    fill: "#AEBED1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11
  }, "How many litres were invoiced?"), /*#__PURE__*/React.createElement("path", {
    d: "M530 314H658 M670 314H766",
    stroke: "#5C718C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310 132H337 M310 278H337 M483 132H510 M483 278H510",
    fill: "none",
    stroke: "#57708E",
    strokeWidth: 2,
    strokeDasharray: "5 7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fcfepShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 190,
    r: 68,
    fill: "#020716",
    stroke: "url(#fcfepGap)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 168L429 212 M429 168L391 212",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 232,
    textAnchor: "middle",
    fill: "#FF86B1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.3,
    fontWeight: 800,
    letterSpacing: 0.75
  }, "ACCOUNTABILITY"), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 244,
    textAnchor: "middle",
    fill: "#FF86B1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 8.3,
    fontWeight: 800,
    letterSpacing: 1
  }, "GAP"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreFuelAccountabilityProblemFragmentedEvidenceModel);
export default __webpack_public_path__ + "static/media/fleetcore-fuel-accountability-problem-fragmented-evidence-model.fcdab3408c671990443d527428274111.svg";
export { ForwardRef as ReactComponent };